<template>
    <el-dialog class="friend-apply im-dialog-shell im-dialog-shell--sm im-dialog-shell--mobile-center" title="申请添加好友" width="400px"
        :visible.sync="isShow" :before-close="onClose" append-to-body>
        <div class="friend-apply__body">
            <el-input type="textarea" v-model="remark" maxlength="255" :autosize="{ minRows: 5 }" show-word-limit>
            </el-input>
            <div class="tip">对方已开启好友验证，提交后需等待对方确认。</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="onClose()" :disabled="submitting">取 消</el-button>
            <el-button type="primary" @click="onOk()" :loading="submitting">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "friendApply",
    components: {},
    data() {
        return {
            isShow: false,
            remark: "",
            userInfo: {},
            submitting: false,
            applyOptions: {}
        }
    },
    methods: {
        open(userInfo, options = {}) {
            this.submitting = false;
            this.isShow = false;
            this.userInfo = userInfo || {};
            this.applyOptions = {
                silent: false,
                defaultRemark: "",
                onSuccess: null,
                afterFailure: null,
                afterClose: null,
                ...options
            };
            this.remark = "我是" + this.userStore.userInfo.nickName;
            const shouldAutoSubmit = this.applyOptions.silent || !this.userInfo.isManualApprove;
            if (this.applyOptions.defaultRemark) {
                this.remark = this.applyOptions.defaultRemark;
            }
            this.isShow = !this.applyOptions.silent && this.userInfo.isManualApprove;
            if (shouldAutoSubmit) {
                // 对方未开启好友验证或快捷模式下，直接发起
                if (!this.userInfo.isManualApprove) {
                    this.remark = "";
                } else {
                    this.remark = this.applyOptions.defaultRemark || ("我是" + this.userStore.userInfo.nickName);
                }
                this.sendApplyRequest();
            }
        },
        onClose() {
            this.closeApply();
        },
        closeApply() {
            this.isShow = false;
            this.submitting = false;
            const afterClose = this.applyOptions.afterClose;
            this.remark = "";
            this.userInfo = {};
            this.applyOptions = {};
            if (typeof afterClose === 'function') {
                afterClose();
            }
            this.$emit('close');
        },
        onOk() {
            this.sendApplyRequest();
        },
        sendApplyRequest() {
            if (this.submitting) {
                return;
            }
            this.submitting = true;
            let formData = {
                friendId: this.userInfo.id,
                remark: this.remark
            }
            this.friendStore.applyFriendRequest(formData).then((request) => {
                if (request.status == this.$enums.REQUEST_STATUS.APPROVED) {
                    this.$message.success(`添加成功，'${this.userInfo.nickName}'已成为您的好友`);
                    let friend = {
                        id: this.userInfo.id,
                        nickName: this.userInfo.nickName,
                        showNickName: this.userInfo.nickName,
                        headImage: this.userInfo.headImageThumb,
                        online: this.userInfo.online,
                        deleted: false
                    }
                    this.friendStore.addFriend(friend);
                } else if (request.status == this.$enums.REQUEST_STATUS.PENDING) {
                    this.$message.success(`您向'${this.userInfo.nickName}'发起了好友申请`);
                    this.friendStore.addRequest(request);
                }
                if (typeof this.applyOptions.onSuccess === 'function') {
                    this.applyOptions.onSuccess(request, this.userInfo);
                }
                this.onClose();
            }).catch(() => {
                // 已由拦截器提示错误，这里仅重置状态
                const options = this.applyOptions || {};
                const userInfo = this.userInfo || {};
                this.submitting = false;
                if (typeof options.afterFailure === 'function') {
                    options.afterFailure(userInfo);
                }
                if (options.silent) {
                    this.closeApply();
                }
            })
        }
    }

}
</script>


<style lang="scss" scoped>
.friend-apply {
    .friend-apply__body {
        display: flex;
        flex-direction: column;
    }

    ::v-deep .el-textarea__inner {
        border-radius: 6px;
        min-height: 118px !important;
    }

    .tip {
        margin-top: 12px;
        padding-top: 10px;
        border-top: 1px solid rgba(var(--im-black-rgb), 0.08);
        color: var(--im-text-color-light);
        font-size: 12px;
        line-height: 1.5;
    }
}
</style>
